import { render, staticRenderFns } from "./dataScreenMain.vue?vue&type=template&id=fd574c4c&scoped=true&"
import script from "./dataScreenMain.vue?vue&type=script&lang=js&"
export * from "./dataScreenMain.vue?vue&type=script&lang=js&"
import style0 from "./dataScreenMain.vue?vue&type=style&index=0&id=fd574c4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd574c4c",
  null
  
)

export default component.exports